import React, { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || '';

export default function AdminLogin({ onSuccess }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/admin/login`, { password }, { withCredentials: true });
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#0d0d1a', fontFamily: 'Tajawal, sans-serif',
    }}>
      <div style={{
        background: '#13131f', border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: '16px', padding: '40px', width: '360px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '28px', marginBottom: '8px' }}>🛡️</div>
          <h1 style={{ margin: 0, fontSize: '20px', color: '#f0f0f5', fontWeight: 700 }}>
            Admin Panel
          </h1>
          <p style={{ margin: '6px 0 0', fontSize: '13px', color: 'rgba(255,255,255,0.4)' }}>
            Smart Converter — Admin Access
          </p>
        </div>

        <form onSubmit={submit}>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Admin password"
            autoFocus
            style={{
              width: '100%', padding: '12px 14px', borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.12)',
              background: 'rgba(255,255,255,0.05)', color: '#f0f0f5',
              fontSize: '14px', outline: 'none', boxSizing: 'border-box',
              marginBottom: '12px',
            }}
          />
          {error && (
            <div style={{
              background: 'rgba(233,69,96,0.12)', border: '1px solid rgba(233,69,96,0.3)',
              borderRadius: '8px', padding: '10px 12px', fontSize: '13px', color: '#e94560',
              marginBottom: '12px',
            }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading || !password}
            style={{
              width: '100%', padding: '12px', borderRadius: '8px',
              background: loading || !password ? 'rgba(99,102,241,0.4)' : '#6366f1',
              border: 'none', color: '#fff', fontWeight: 700, fontSize: '14px',
              cursor: loading || !password ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Logging in…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
